import FJAppConstant from '../../../../constants/FJAppConstant.js';
import styles from './FJAIPhotoGeneratorRight.module.less';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer.jsx';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer.jsx';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer.jsx';
import FJFilterAndSearchContainer from '../container/FJFilterAndSearchContainer.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJCommunityHomeContainer from '../../../FJCommunity/FJCommunityRight/FJCommunityHome/FJCommunityHomeContainer.jsx';

const FJAIPhotoGeneratorRight = props => {
    // TextToImage
    const { tabType, onRetry, isShowPresetImageBox, headerTabIndex } = props;

    return (
        <div className={styles.app_right}>
            <FJDisplayHeaderContainer hideCancelButton={true} />
            <FJCommunityHomeContainer active={headerTabIndex === FJConstant.COMMUNITY} embedded={true} />

            <FJCreationPanelContainer
                activeHeaderTabIndex={tabType === FJAppConstant.TEXT_TO_IMAGE ? FJConstant.CREATIONS : ''}
                hideCompare={true}
                onRetry={onRetry}
                isShowPresetImageBox={isShowPresetImageBox}
                appType={FJAppConstant.TEXT_TO_IMAGE}
            />

            <FJCreationPanelContainer
                activeHeaderTabIndex={tabType === FJAppConstant.IMAGE_TO_IMAGE ? FJConstant.CREATIONS : ''}
                appType={FJAppConstant.IMAGE_TO_IMAGE}
            />

            <FJCreationPanelContainer
                activeHeaderTabIndex={tabType === FJAppConstant.AI_PHOTO_EDITOR ? FJConstant.CREATIONS : ''}
                isShowPresetImageBox={isShowPresetImageBox}
                bkColor='var(--bg-color-sub)'
                onRetry={onRetry}
                appType={FJAppConstant.AI_PHOTO_EDITOR}
            />

            <FJHistoryPanelContainer
                activeHeaderTabIndex={FJConstant.HISTORY}
                headerChildren={<FJFilterAndSearchContainer />}
                isImageList={true}
            />
        </div>
    );
};
export default FJAIPhotoGeneratorRight;
